import { BehaviorSubject } from 'rxjs'

export interface ObserverArrayItem {
  key: string
  observable: BehaviorSubject<any>
}

export class ObservableService {
  private static instance: ObservableService
  private observerArray: ObserverArrayItem[] = []

  private constructor() {}

  static getInstance(): ObservableService {
    if (!ObservableService.instance) {
      ObservableService.instance = new ObservableService()
    }
    return ObservableService.instance
  }

  createObservable(key: string) {
    const observable = new BehaviorSubject(null)
    this.observerArray.push({ key, observable })
  }

  getObservable(key: string) {
    const observableArrayItem = this.observerArray.find(
      (obs) => obs.key === key
    )
    return observableArrayItem?.observable
  }

  emitValue(key: string, data: any) {
    const observableArrayItem = this.observerArray.find(
      (obs) => obs.key === key
    )

    observableArrayItem?.observable.next(data)
  }

  destroyObservable(key: string) {
    const selectedObservable = this.observerArray.find((obs) => obs.key === key)
    selectedObservable?.observable.unsubscribe()
    this.observerArray = this.observerArray.filter((obs) => obs.key !== key)
  }
}
